module.exports = __webpack_public_path__ + "img/off-mode.82a1d4aa.svg";